"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _androidinfo = require("../../api/androidinfo.js");
var _awsSdk = _interopRequireDefault(require("aws-sdk"));
var _axios = _interopRequireDefault(require("axios"));
var _aliOss = _interopRequireDefault(require("ali-oss"));
var _jsMd = _interopRequireDefault(require("js-md5"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Androidinfo',
  data: function data() {
    return {
      selectedFile: null,
      progress: 0,
      percentage: "",
      isDisable: false,
      value: "",
      loading: false,
      tableData: [],
      form: {
        dependencySystem: "",
        status: "",
        version: "",
        pageNo: 1,
        pageSize: 10,
        type: ""
      },
      types: [{
        value: "1",
        label: "系统"
      }, {
        value: "2",
        label: "应用"
      }],
      isstatus: [{
        value: "0",
        label: "未审核"
      }, {
        value: "1",
        label: "已审核"
      }],
      currentPage: 1,
      total: 0,
      rowid: "",
      checks: {
        auditFlag: "",
        auditInfo: "",
        id: ""
      },
      testDialog: false,
      formLabelWidth: "120px",
      testOption: [{
        label: "同意",
        value: "Y"
      }, {
        label: "不同意",
        value: "N"
      }],
      current: null,
      dialogFormVisible: false,
      buttonUpload: "点击上传",
      saveButton: "保存",
      disab: false,
      savedisab: false,
      keyId: "K66NRBmhuzqh6QX36ICAKIAVT4",
      secretId: "zlMc+UDjkbfloun7DrYRHfJQNupFNQfZuKHd49NL8jqu2x",
      ufileKeyId: "DZ6AMdbKW54tdbbnzqikFxwHYPAJ4ZDugctlNo9",
      ufileSecretId: "DY2OpDusgX65jFGrbqcqs9bCLLp6DkpenI6VCxKzZ7pRlO6Hdt",
      privateKey_1: "XAkWgD0A",
      privateKey_2: "KSVDWG",
      uploads: {
        area: "",
        custom: "",
        dependencySystem: "",
        fileName: "",
        name: "",
        packageName: "",
        platform: "",
        type: "",
        versionNo: "",
        version: ""
      },
      dependencySystem: "",
      useflag: false,
      versions: [],
      useType: "",
      istype: "",
      area: "",
      custom: "",
      platform: "",
      fileName: "",
      version: "",
      size: "",
      md5: "",
      fileNames: ""
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      setTimeout(function () {
        (0, _androidinfo.getAndroidInfo)(_this.form).then(function (res) {
          _this.tableData = res.voList;
          _this.total = res.total;
          _this.loading = false;
          _this.isRepeat = false;
        });
      }, 500);
    },
    //分页
    changepage: function changepage(currentPage) {
      this.currentPage = currentPage;
      this.form.pageNo = currentPage;
      this.getList();
    },
    //查询
    search: function search() {
      var _this2 = this;
      this.loading = true;
      setTimeout(function () {
        (0, _androidinfo.getAndroidInfo)({
          dependencySystem: _this2.form.dependencySystem,
          status: _this2.form.status,
          version: _this2.form.version,
          pageNo: 1,
          pageSize: 10,
          type: _this2.form.type
        }).then(function (res) {
          _this2.tableData = res.voList;
          _this2.total = res.total;
          _this2.loading = false;
          _this2.currentPage = 1;
          _this2.isRepeat = false;
        });
      }, 500);
    },
    //清空
    empty: function empty() {
      this.form.dependencySystem = "";
      this.form.status = "";
      this.form.version = "";
      this.form.type = "";
      this.currentPage = 1;
      this.form.pageNo = 1;
      this.getList();
    },
    //判断类型
    equimentType: function equimentType(row) {
      if (row.type == "1") {
        return "系统";
      } else {
        return "应用";
      }
    },
    //判断审核结果
    audit: function audit(row) {
      if (row.auditFlag == "Y") {
        return "同意";
      } else if (row.auditFlag == "N") {
        return "不同意";
      }
    },
    //判断版本状态
    statusInfo: function statusInfo(row) {
      if (row.status == "0") {
        return "未审核";
      } else if (row.status == "1") {
        return "已审核";
      }
    },
    // 使用浏览器原生API计算大文件MD5（兼容1G+文件）
    calculateFileMD5: function () {
      var _calculateFileMD = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(file) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                var md5 = _jsMd.default.create();
                var chunkSize = 2 * 1024 * 1024;
                var offset = 0;
                var readNextChunk = function readNextChunk() {
                  var chunk = file.slice(offset, offset + chunkSize);
                  var reader = new FileReader();
                  reader.onload = function (e) {
                    md5.update(e.target.result);
                    offset += chunkSize;
                    if (offset < file.size) {
                      readNextChunk();
                    } else {
                      resolve(md5.hex());
                    }
                  };
                  reader.onerror = reject;
                  reader.readAsArrayBuffer(chunk);
                };
                readNextChunk();
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function calculateFileMD5(_x) {
        return _calculateFileMD.apply(this, arguments);
      }
      return calculateFileMD5;
    }(),
    //上传
    upload: function upload() {
      this.dialogFormVisible = true;
    },
    submitUpload: function () {
      var _submitUpload = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this3 = this;
        var fileData, formFile, index, str, extension, req, userType, type;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              fileData = this.$refs.uploadFile.files[0];
              this.selectedFile = fileData;
              formFile = new FormData(); //加入文件对象
              formFile.append("file", fileData);
              if (!(this.buttonUpload != "点击上传")) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return");
            case 6:
              index = fileData.name.lastIndexOf(".");
              str = fileData.name.substring(index + 1, fileData.name.length);
              extension = str === "zip";
              this.loading = true;
              this.savedisab = true;
              this.istype = fileData.name.toLowerCase().indexOf("(");
              //判断是不是zip
              if (!extension) {
                _context2.next = 39;
                break;
              }
              if (!(fileData.name.toLowerCase().indexOf("(") > -1)) {
                _context2.next = 17;
                break;
              }
              (0, _androidinfo.beforeupload)(formFile).then(function (res) {
                if (res.success) {
                  _this3.buttonUpload = res.voT.fileName;
                  _this3.useType = res.voT.type;
                  if (res.voT.type == "2") {
                    _this3.useflag = true;
                    _this3.uploads = res.voT;
                    (0, _androidinfo.searchapk)({
                      area: res.voT.area,
                      custom: res.voT.custom
                    }).then(function (item) {
                      _this3.versions = item.voList;
                    });
                  } else if (res.voT.type == "1") {
                    _this3.uploads = res.voT;
                  }
                  _this3.disab = true;
                  _this3.loading = false;
                  _this3.savedisab = false;
                  _this3.$refs.uploadFile.value = null;
                } else {
                  _this3.loading = false;
                  _this3.savedisab = false;
                  _this3.msgTip("error", res.errorMsg);
                  _this3.$refs.uploadFile.value = null;
                }
              });
              _context2.next = 37;
              break;
            case 17:
              this.useType = "1";
              _context2.prev = 18;
              _context2.next = 21;
              return this.calculateFileMD5(fileData);
            case 21:
              this.md5 = _context2.sent;
              console.log('可靠MD5:', this.md5);
              _context2.next = 30;
              break;
            case 25:
              _context2.prev = 25;
              _context2.t0 = _context2["catch"](18);
              console.error('计算失败:', _context2.t0);
              this.msgTip("error", "计算MD5失败");
              return _context2.abrupt("return");
            case 30:
              req = new XMLHttpRequest();
              req.open("GET", document.location, false);
              req.send(null);
              userType = req.getResponseHeader("Domain") ? req.getResponseHeader("Domain") : ""; //userType = "cn";
              console.log(userType, "Domain");
              type = fileData.type;
              (0, _androidinfo.getUpload)({
                fileName: "update.zip",
                folder: "1"
              }).then(function (res) {
                if (res.success) {
                  _this3.fileNames = res.s3Url.substr(res.s3Url.lastIndexOf("/", res.s3Url.lastIndexOf("/") - 1) + 1);
                  if (userType == "cn") {
                    var data = {
                      file: fileData,
                      fileRename: _this3.fileNames
                    };
                    //ali云上传
                    console.log("ali云上传");
                    var _accessKeyId = _this3.decryption(res.accessKeyId);
                    var accessKeySecret = _this3.decryption(res.accessKeySecret);
                    var bucket = res.bucketName;
                    var clientOssAli = new _aliOss.default({
                      accessKeyId: _accessKeyId,
                      accessKeySecret: accessKeySecret,
                      bucket: bucket,
                      endpoint: "supernote.com.cn"
                    });
                    var innerName1 = _this3.fileNames;
                    console.log(innerName1);
                    //调用阿里云Oss上传方法
                    _this3.startUpload(fileData, clientOssAli, innerName1);
                  } else {
                    var decryptedPart1 = _this3.keyId.slice(-7);
                    var decryptedPart2 = _this3.keyId.slice(-14, -7).split("").reverse().join("");
                    var decryptedPart3 = _this3.keyId.slice(0, -14).slice(0, -6).split("").reverse().join("");
                    var accessKeyId = decryptedPart1 + decryptedPart2 + decryptedPart3;
                    var secretdecryptedPart1 = _this3.secretId.slice(-15);
                    var secretdecryptedPart2 = _this3.secretId.slice(-31, -15).split("").reverse().join("");
                    var secretreversedPart3 = _this3.secretId.slice(0, -31).slice(0, -6).split("").reverse().join("");
                    var secretAccessKey = secretdecryptedPart1 + secretdecryptedPart2 + secretreversedPart3;
                    var s3 = new _awsSdk.default.S3({
                      accessKeyId: accessKeyId,
                      secretAccessKey: secretAccessKey,
                      region: "ap-northeast-1"
                    });
                    var params = {
                      Bucket: "prod-ratta-firmware",
                      Key: _this3.fileNames,
                      ContentType: _this3.selectedFile.type,
                      ACL: "public-read"
                    };
                    s3.getSignedUrl("putObject", params, function (error, url) {
                      if (error) {
                        console.error("获取预签名URL失败：", error);
                        return;
                      }
                      var xhr = new XMLHttpRequest();
                      xhr.open("PUT", url, true);
                      xhr.setRequestHeader("Content-Type", _this3.selectedFile.type);
                      xhr.upload.addEventListener("progress", function (event) {
                        if (event.lengthComputable) {
                          console.log("上传进度:", Math.round(event.loaded / event.total * 100));
                          _this3.progress = Math.round(event.loaded / event.total * 100);
                        }
                      });
                      xhr.onreadystatechange = function () {
                        if (xhr.readyState === XMLHttpRequest.DONE) {
                          if (xhr.status === 200) {
                            console.info("文件上传成功");
                            _this3.buttonUpload = fileData.name;
                            _this3.area = fileData.name.split(".")[1].substring(1, 2);
                            _this3.custom = fileData.name.split(".")[1].substring(2, 3);
                            _this3.platform = fileData.name.split(".")[1].substring(3, 4);
                            _this3.fileName = fileData.name;
                            var index = fileData.name.lastIndexOf(".");
                            _this3.version = fileData.name.substring(0, index);
                            _this3.size = fileData.size;
                            _this3.disab = true;
                            _this3.loading = false;
                            _this3.savedisab = false;
                            _this3.$refs.uploadFile.value = null;
                          } else {
                            console.error("文件上传失败：", xhr.statusText);
                          }
                        }
                      };
                      xhr.send(_this3.selectedFile);
                    });
                  }
                }
              });
            case 37:
              _context2.next = 44;
              break;
            case 39:
              this.msgTip("error", "上传文件只能是zip格式!");
              return _context2.abrupt("return");
            case 44:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[18, 25]]);
      }));
      function submitUpload() {
        return _submitUpload.apply(this, arguments);
      }
      return submitUpload;
    }(),
    //阿里云OSS上传
    startUpload: function () {
      var _startUpload = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(fileData, clientOssAli, innerName1) {
        var _this4 = this;
        var result, index;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return clientOssAli.multipartUpload("/" + innerName1,
              // 目标Bucket中的文件路径
              fileData,
              // 本地文件路径
              {
                progress: function progress(percent) {
                  console.log("\u4E0A\u4F20\u8FDB\u5EA6: ".concat(Math.round(percent * 100), "%"));
                  _this4.progress = Math.round(percent * 100);
                }
              });
            case 3:
              result = _context3.sent;
              console.log("上传成功:", result);
              this.buttonUpload = fileData.name;
              this.area = fileData.name.split(".")[1].substring(1, 2);
              this.custom = fileData.name.split(".")[1].substring(2, 3);
              this.platform = fileData.name.split(".")[1].substring(3, 4);
              this.fileName = fileData.name;
              index = fileData.name.lastIndexOf(".");
              this.version = fileData.name.substring(0, index);
              this.size = fileData.size;
              this.disab = true;
              this.loading = false;
              this.savedisab = false;
              this.$refs.uploadFile.value = null;
              _context3.next = 23;
              break;
            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](0);
              console.error("UploadError:", _context3.t0);
              this.msgTip("error", "上传文件失败！");
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 19]]);
      }));
      function startUpload(_x2, _x3, _x4) {
        return _startUpload.apply(this, arguments);
      }
      return startUpload;
    }(),
    // 解密函数
    decryption: function decryption(encryptionStr) {
      if (encryptionStr === null || encryptionStr === "") {
        return encryptionStr;
      }
      var decryptedStr = "";
      var length = Math.ceil(encryptionStr.length / 2);
      for (var i = 0; i < length; i++) {
        var charCode = parseInt(encryptionStr.substring(i * 2, i * 2 + 2), 16) - 1;
        decryptedStr += String.fromCharCode(charCode);
      }
      var startIndex = this.privateKey_1.length;
      var endIndex = decryptedStr.length - this.privateKey_2.length;
      endIndex = Math.max(endIndex, 0);
      return decryptedStr.substring(startIndex, endIndex);
    },
    // 更新上传进度
    updateUploadProgress: function updateUploadProgress(fileName, progressEvent) {
      var progress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
      this.msgList = this.msgList.map(function (item) {
        if (item.fileName === fileName) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
            progress: progress
          });
        }
        return item;
      });
    },
    //上传保存
    save: function save() {
      var _this5 = this;
      if (this.savedisab == true) {
        return;
      }
      if (this.useType == "2") {
        if (this.uploads.version == "") {
          this.msgTip("warning", "请选择版本号");
          return;
        } else if (this.dependencySystem == "") {
          this.msgTip("warning", "请选择系统");
          return;
        } else {
          this.savedisab = true;
          this.saveButton = "正在保存";
          this.isRepeat = true;
          this.loading = true;
          (0, _androidinfo.upload)({
            area: this.uploads.area,
            custom: this.uploads.custom,
            dependencySystem: this.dependencySystem,
            fileName: this.uploads.fileName,
            name: this.uploads.name,
            packageName: this.uploads.packageName,
            platform: this.uploads.platform,
            type: this.uploads.type,
            versionNo: this.uploads.versionNo,
            version: this.uploads.version
          }).then(function (res) {
            if (res.success) {
              _this5.msgTip("success", "上传成功");
              _this5.$refs.uploadFile.value = [];
              _this5.buttonUpload = "点击上传";
              _this5.saveButton = "保存";
              _this5.dialogFormVisible = false;
              _this5.savedisab = false;
              _this5.uploadClose();
              _this5.dependencySystem = "";
              _this5.disab = false;
              _this5.getList();
            } else {
              _this5.msgTip("error", res.errorMsg);
              _this5.$refs.uploadFile.value = [];
              _this5.buttonUpload = "点击上传";
              _this5.saveButton = "保存";
              _this5.dependencySystem = "";
              _this5.disab = false;
              _this5.savedisab = false;
              _this5.isRepeat = false;
              _this5.loading = false;
            }
          });
        }
      } else if (this.useType == "1") {
        this.savedisab = true;
        this.saveButton = "正在保存";
        this.isRepeat = true;
        this.loading = true;
        (0, _androidinfo.upload)({
          type: "1",
          area: this.area,
          custom: this.custom,
          platform: this.platform,
          innerName: this.fileNames,
          fileName: this.fileName,
          version: this.version,
          //去掉.zip
          size: this.size,
          md5: this.md5
        }).then(function (res) {
          if (res.success) {
            _this5.msgTip("success", "上传成功");
            _this5.$refs.uploadFile.value = [];
            _this5.buttonUpload = "点击上传";
            _this5.saveButton = "保存";
            _this5.disab = false;
            _this5.dialogFormVisible = false;
            _this5.savedisab = false;
            _this5.uploadClose();
            _this5.getList();
          } else {
            _this5.msgTip("error", res.errorMsg);
            _this5.$refs.uploadFile.value = [];
            _this5.buttonUpload = "点击上传";
            _this5.saveButton = "保存";
            _this5.disab = false;
            _this5.savedisab = false;
            _this5.isRepeat = false;
            _this5.loading = false;
          }
        });
      }
    },
    uploadClose: function uploadClose() {
      this.dialogFormVisible = false;
      this.$refs.uploads.resetFields();
      this.buttonUpload = "点击上传";
      this.saveButton = "保存";
      this.savedisab = false;
      this.useflag = false;
      this.disab = false;
      this.progress = 0;
    },
    handleClick: function handleClick(val) {
      this.current = val;
    },
    //审核
    check: function check() {
      if (this.current == undefined || this.current == null || this.current.length < 1) {
        this.msgTip("error", "请选择需要审核的记录！");
      } else {
        if (this.current.status == "1") {
          this.msgTip("warning", "已审核，不允许再次被审核！");
        } else {
          this.checks.auditFlag = "Y";
          this.testDialog = true;
          this.isDisable = false;
        }
      }
    },
    testSave: function testSave() {
      var _this6 = this;
      (0, _androidinfo.auditAndroidInfo)({
        auditFlag: this.checks.auditFlag,
        auditInfo: this.checks.auditInfo,
        id: this.current.id
      }).then(function (res) {
        if (res.success) {
          _this6.msgTip("success", "审核通过");
          _this6.testDialog = false;
          //  // 获取当前日期 时间
          // dataManipulation(
          //     this.tableData,
          //     "已审核",
          //     this.checks.auditFlag,
          //     this.checks.auditInfo,
          //     "",
          //     getDate()
          //  );
          _this6.getList();
        }
      });
    },
    //审核关闭
    close: function close() {
      this.testDialog = false;
      this.checks.auditInfo = "";
    },
    //信息提示框
    msgTip: function msgTip(msgType, msgInfo) {
      this.$message({
        type: msgType,
        message: msgInfo,
        center: true
      });
    },
    //删除
    dele: function dele() {
      var _this7 = this;
      if (this.current == undefined || this.current == null || this.current.length < 1) {
        this.msgTip("error", "请选择需要删除的记录！");
        return;
      }
      {
        this.$confirm("您是否要删除当前选中的记录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          (0, _androidinfo.deleteAndroidInfo)(_this7.current.id).then(function (res) {
            if (res.success) {
              _this7.$message({
                type: "success",
                message: "删除成功",
                center: true
              });
              _this7.getList();
            } else {
              _this7.$message({
                type: "error",
                message: res.errorMsg,
                center: true
              });
            }
          });
        });
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    }
  }
};
/**
 * 获取当前时间.
 */
function getDate() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  var hours = date.getHours(); //获取当前小时数(0-23)
  var minutes = date.getMinutes(); //获取当前分钟数(0-59)
  var seconds = date.getSeconds();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate + " " + hours + ":" + minutes + ":" + seconds;
  return currentdate;
}